// Reports English translations
export const reportsEn = {
  'actual.route': 'Actual Route',
  'actual.route.gps': 'Actual Route (GPS)',
  'actual.route.tolls': 'Actual Route Tolls',
  'analyzing': 'Analyzing',
  'avg.speed.limit': 'Avg Speed Limit',
  'click.record.to.view.analysis': 'Click on a record from the list to view route and cost analysis',
  'click.to.analyze': 'Click to analyze',
  'cost.analysis': 'Cost Analysis',
  'cost.comparison': 'Cost Comparison',
  'currently.analyzing': 'Currently Analyzing',
  'daily.financial.report': 'Daily Financial Report',
  'daily.profit.chart': 'Daily Profit Trend',
  'difference': 'Difference',
  'distance.difference': 'Distance Difference',
  'duration': 'Duration',
  'efficient.route.taken': 'Efficient Route Taken',
  'enable.route.display': 'Enable Route Display',
  'export.route.points': 'Export Route Points (JSON)',
  'fee.comparison': 'Fee Comparison',
  'filtered.points': 'Filtered Points',
  'fuel.cost': 'Fuel Cost',
  'fuel.savings': 'Fuel Savings',
  'loading.addresses': 'Loading 3 addresses at a time',
  'loading.shipping.records': 'Loading shipping records...',
  'max.speed.limit': 'Max Speed Limit',
  'monthly.financial.report': 'Monthly Financial Report',
  'no.shipping.records.found': 'No Shipping Records Found',
  'no.toll.fees.detected': 'No Toll Fees Detected',
  'no.toll.on.visible.routes': 'No toll fee locations found on visible routes',
  'optimal.route': 'Optimal Route',
  'optimal.route.osrm': 'Optimal Route (OSRM)',
  'optimal.route.tolls': 'Optimal Route Tolls',
  'potential.savings.identified': 'Potential Savings Identified',
  'profit': 'Profit',
  'route.points': 'Route Points',
  'route.statistics': 'Route Statistics',
  'route.visualization': 'Route Visualization',
  'select.shipping.record.to.analyze': 'Select a shipping record to analyze',
  'shipping.cost.analysis': 'Shipping Cost Analysis',
  'shipping.records': 'Shipping Records',
  'showing.points.30min.apart': 'Showing points ?30 min apart',
  'toggle.route.visibility': 'Toggle route visibility to see toll locations',
  'toll.fee': 'Toll Fee',
  'toll.fee.locations': 'Toll Fee Locations',
  'total.actual.fees': 'Total Actual Route Fees:',
  'total.cost': 'Total Cost',
  'total.optimal.fees': 'Total Optimal Route Fees:',
  'total.points': 'Total Points',
  'total.savings': 'Total Savings',
  'try.adjusting.filters': 'Try adjusting the date filter or create a new shipping record',
  'you.could.save': 'You could save by taking the optimal route',
};
